module.exports = __webpack_public_path__ + "img/way_i.9998fb2d.png";